/**
 * Platform Message API
 *
 * Generic function for sending platform messages.
 */
import { api, makeMutationFn } from 'shared/api';

import { SendMessageRequest } from './types';

/**
 * Send a platform message to the backend
 *
 * @param request - The message request containing type and payload
 * @returns Promise that resolves when message is sent (void response)
 */
export const sendMessage = makeMutationFn<
    SendMessageRequest,
    void
>(async (request) => {
    return await api.post<SendMessageRequest, void>('/platformMessages', request);
});
